export interface CsvColumn<T> {
  key: keyof T | string
  label: string
  value?: (row: T) => string | number | null | undefined
}

const CSV_BOM = '\uFEFF'
const CSV_NEWLINE = '\r\n'

function escapeCell(value: unknown): string {
  if (value === null || value === undefined) return ''
  const str = String(value)
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

export function toCsv<T>(rows: T[], columns: CsvColumn<T>[]): string {
  const header = columns.map((col) => escapeCell(col.label)).join(',')
  const body = rows.map((row) =>
    columns
      .map((col) => {
        const raw = col.value ? col.value(row) : (row as Record<string, unknown>)[col.key as string]
        return escapeCell(raw)
      })
      .join(','),
  )
  return [header, ...body].join(CSV_NEWLINE)
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([CSV_BOM + csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export function csvTimestamp(date: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return (
    date.getFullYear().toString() +
    pad(date.getMonth() + 1) +
    pad(date.getDate()) +
    '_' +
    pad(date.getHours()) +
    pad(date.getMinutes())
  )
}
